// extracted by mini-css-extract-plugin
export default {"container":"VTC5aKen7jD4s5m8q_pr","nickname":"wdWc3mIF_y1faGmI2SgM"};